import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { image } from '../../../../app/utils/common/image';
import Input from '../../../atoms/Input/Input';
import Button from '../../../atoms/Button/Button';
import './AddManageBroker.scss'
import { getImageURL } from '../../../../app/utils/common/getImageUrl';
import ErrorText from '../../../atoms/Error/error';
import { validateEmail, validatePhoneNumber } from '../../../../app/utils/common/validation';
import { useAppDispatch, useAppSelector } from '../../../../app/utils/hooks/reduxHook';
import { uploadFile } from '../../../../redux/API/ProjectAPI';
import { showErrorToast } from '../../../../app/utils/common/Toast';
import { createBrokerAPI, updateBrokerAPI } from '../../../../redux/API/BrokerAPI';
import LoaderScreen from '../../../atoms/LoaderScreen/LoaderScreen';
import { setBrokerLoading } from '../../../../redux/Slices/brokerSlice';

const AddManageBroker = () => {
    const navigate = useNavigate()
    const { currentBroker, loading } = useAppSelector(state => state.broker)
    const [name, setName] = useState<string>('');
    const [newProfilePhoto, setNewProfilePhoto] = useState<File>();
    const [profilePhoto, setProfilePhoto] = useState<string>();
    const [email, setEmail] = useState<string>('');
    const [phone, setPhone] = useState<string>('');
    const [showError, setShowError] = useState<boolean>(false);
    const [isDataChange, setIsDataChange] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    let { type } = useParams();

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (type) {
            if (!["create", "edit"].includes(type)) {
                navigate("/login");
            }
        } else {
            navigate("/login");
        }
    }, [])
    useEffect(() => {
        if (currentBroker) {
            if (handleDataChange()) {
                setIsDataChange(true);
            } else {
                setIsDataChange(false);
            }
        }
    }, [name, email, newProfilePhoto, phone])

    useEffect(() => {
        if (type === "edit") {
            if (currentBroker) {
                setName(currentBroker.name);
                setPhone(currentBroker.phone_number);
                setEmail(currentBroker.email ?? '');
                if (currentBroker.profile_image) {
                    setProfilePhoto(currentBroker.profile_image);
                }
            } else {
                navigate("/dashboard/manage-broker");
            }
        }
    }, [])
    // console.log('loading :>> ', loading);
    const handleDataChange = () => {
        if (currentBroker) {
            if (currentBroker.name !== name.trim() || currentBroker.email !== email || currentBroker.phone_number !== phone || newProfilePhoto) return true;
            return false;
        }
        return false;
    }

    const handleSubmit = async () => {
        if (validatePhoneNumber(phone) && name.trim().length > 0) {
            // api call
            let profile_image_url;
            if (newProfilePhoto) {
                try {
                    dispatch(setBrokerLoading(true))
                    const imageResp = await uploadFile([newProfilePhoto], "profile");
                    profile_image_url = imageResp.data.imageUrls[0];
                } catch (err) {
                    showErrorToast("Error in uploading profile image.");
                    dispatch(setBrokerLoading(false));
                    return;

                }
            }
            if (type === "create") {
                dispatch(createBrokerAPI({
                    name,
                    email,
                    phone_number: phone,
                    profile_image: profile_image_url,
                    country_code: '+91'
                })).unwrap().then(() => {
                    navigate("/dashboard/manage-broker");
                }).catch(err => {
                    // console.log("broker creation error", err);
                })
            } else if (type === "edit" && isDataChange && currentBroker) {
                let updatedData: any = {}
                if (newProfilePhoto) updatedData.profile_image = profile_image_url;
                if (currentBroker?.name !== name.trim()) updatedData.name = name;
                if (currentBroker?.email !== email) updatedData.email = email;
                if (currentBroker?.phone_number !== phone) {
                    updatedData.phone_number = phone;
                    updatedData.country_code = "+91";
                }
                updatedData.cpId = currentBroker.cp_id;
                dispatch(updateBrokerAPI(updatedData)).unwrap().then(() => {
                    navigate("/dashboard/manage-broker");
                }).catch(err => {
                    // console.log("broker update error", err);
                });
            }
        } else {
            setShowError(true);
        }
    }
    return (
        <div className='create_project_container' >
            {
                <input type='file' accept='image/*' style={{ display: "none" }} ref={inputRef} onChange={(e) => {
                    if (e.target.files) {
                        setNewProfilePhoto(e.target.files[0])
                    }
                }} />
            }
            <div className='create_project_header_container'>
                <img className='back_icon' src={image.BACK_ICON} onClick={() => {
                    navigate(-1);
                }} />
                <div className='header_text'>{type === "create" ? "Add" : "Edit"} Broker</div>
            </div>
            <div className='group-details-container broker-add-container'>
                <div className='group-container add-broker-container'>
                    <div style={{ position: "relative" }}>
                        <div>
                            <img src={newProfilePhoto ? URL.createObjectURL(newProfilePhoto) : profilePhoto ? getImageURL(profilePhoto) : image.DEFAULT_PROFILE_IMAGE} className='broker-profile' />
                            <img src={image.CAMERA_PHOTO} alt="camera icon" className="broker-camera_image add-broker" onClick={() => inputRef.current?.click()} />
                        </div>
                    </div>
                    <div className='broker-main-container'>
                        <div className='group-name-container'>
                            <div className='group-photo'>Name</div>
                            <Input
                                placeholder="Enter Name"
                                type="text"
                                name="broker Name"
                                id="brokerName"
                                value={name}
                                onChange={(e) => { setName(e.target.value) }}
                                iconSrc={image.USER_NAME_ICON}
                                showIcon={true}
                            />
                            {showError && name.trim().length == 0 && <ErrorText message="Please provide broker's name" />}
                        </div>
                        {/* <div className='group-name-container'>
                            <div className='group-photo'>Email ID</div>
                            <Input
                                placeholder="Enter Email"
                                type="email"
                                name="broker Email"
                                id="brokerEmail"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value) }}
                                iconSrc={image.EmailLogo}
                                showIcon={true}
                            />
                            {showError && !validateEmail(email) && <ErrorText message="Please provide valid broker's email." />}
                        </div> */}
                        <div className='group-name-container'>
                            <div className='group-photo'>Phone Number</div>
                            <Input
                                placeholder="Enter Phone Number"
                                type="number"
                                name="broker number"
                                id="brokerNumber"
                                value={phone}
                                onChange={(e) => { if (e.target.value.length <= 10) setPhone(e.target.value) }}
                                iconSrc={image.PhoneLogo}
                                showIcon={true}
                            />
                            {showError && !validatePhoneNumber(phone) && <ErrorText message="Please provide valid broker's phone number." />}
                        </div>
                    </div>
                    <div className='grp-submit-container' style={{ marginLeft: "0px" }}>
                        {
                            loading ? <LoaderScreen /> :
                                <Button buttonTitle={type === "create" ? "Submit" : "Update"} onClick={() => handleSubmit()} className='group_btn_submit' />
                        }
                    </div>
                </div>

            </div>



        </div>
    )
}

export default AddManageBroker